// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1E0Se","title":"ClientReferral_title__3COGF","itemText":"ClientReferral_itemText__2HblC"};